import { GAME_CONFIG } from '../config/constants';
    import { MENTORS } from '../data/mentors';
    
    export class GameService {
      static calculateSPS(planters, gardeners, autoLevel, mentorSps, compost) {
        const { planterRate, gardenerRate } = GAME_CONFIG.production;
        const safePlanters = planters || 0;
        const safeGardeners = gardeners || 0;
        const safeAutoLevel = autoLevel || 1;
        const safeMentorSps = mentorSps || 0;
        const safeCompost = compost || 1.0;
    
        const itemProduction = (safePlanters * planterRate) + (safeGardeners * gardenerRate);
        const autoMultiplier = Math.pow(1.25, safeAutoLevel - 1);
        const totalBaseSPS = (itemProduction * autoMultiplier) + safeMentorSps;
    
        return totalBaseSPS * safeCompost;
      }
    
      static calculateClickYield(effLevel, compost) {
        const safeEffLevel = effLevel || 1;
        const safeCompost = compost || 1.0;
        return (1 + 0.5 * (safeEffLevel - 1)) * safeCompost;
      }
    
      static calculatePlanterCost(currentPlanters) {
        const count = currentPlanters || 0;
        return Math.floor(GAME_CONFIG.production.planterBaseCost * Math.pow(GAME_CONFIG.production.costMultiplier, count));
      }
    
      static calculateGardenerCost(currentGardeners) {
        const count = currentGardeners || 0;
        return Math.floor(GAME_CONFIG.production.gardenerBaseCost * Math.pow(GAME_CONFIG.production.costMultiplier, count));
      }
    
      static calculateEfficiencyCost(currentLevel) {
        const level = currentLevel || 1;
        return Math.floor(GAME_CONFIG.upgrades.efficiencyBase * Math.pow(GAME_CONFIG.upgrades.upgradeMultiplier, level - 1));
      }
    
      static calculateAutomationCost(currentLevel) {
        const level = currentLevel || 1;
        return Math.floor(GAME_CONFIG.upgrades.automationBase * Math.pow(GAME_CONFIG.upgrades.upgradeMultiplier, level - 1));
      }
    
      static calculatePrestigeRequirement(prestigeLevel) {
        const level = prestigeLevel || 0;
        const { prestigeBaseRequirement, prestigeCostMultiplier } = GAME_CONFIG.prestige;
        return Math.floor(prestigeBaseRequirement * Math.pow(prestigeCostMultiplier, level));
      }
    
      static calculateFocusReward(minutes, compost) {
        const safeMinutes = minutes || 25;
        const safeCompost = compost || 1.0;
        return Math.ceil(10 * safeMinutes * safeCompost);
      }
    
      static canAffordPurchase(seeds, cost) {
        return (seeds || 0) >= (cost || 0);
      }
    
      static getProductionRates() {
        return {
          planterRate: GAME_CONFIG.production.planterRate,
          gardenerRate: GAME_CONFIG.production.gardenerRate,
        };
      }
    
      static calculateMentorSpsContribution(mentor, level) {
        if (!mentor || !mentor.spsGrant) return 0;
        const effectiveLevel = level || 1;
        // Each level adds 25% of the base SPS grant.
        return mentor.spsGrant * (1 + 0.25 * (effectiveLevel - 1));
      }
    
      static calculateTotalMentorSps(ownedCharacters, mentorLevels) {
        let totalSps = 0;
        if (!ownedCharacters) return 0;
        ownedCharacters.forEach(key => {
          const mentor = MENTORS[key];
          if (mentor) {
            totalSps += this.calculateMentorSpsContribution(mentor, mentorLevels?.[key]);
          }
        });
        return totalSps;
      }
    
      static calculateMentorUpgradeCost(mentor, level) {
        if (!mentor.upgradeBaseCost) return Infinity; // Cannot be upgraded
        const currentLevel = level || 1;
        const multiplier = mentor.upgradeCostMultiplier || 1.5;
        return Math.floor(mentor.upgradeBaseCost * Math.pow(multiplier, currentLevel - 1));
      }
    }